export function countWordsFromTextComponents(arr) {
  const textArray = arr
    .filter(obj => obj.component === 'text')
    .map(obj => obj.body)
  const textString = textArray.join(' ')
  const words = textString.split(' ')
  return words.length
}
